module.exports = __webpack_public_path__ + "static/media/turkey-bacon-club.48c21e92.jpg";